import { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IonPopover } from '@ionic/react';
import * as Icons from 'ionicons/icons';
import { AllieAvatar } from '../../../../components';
import './AvatarInfo.scss';

export interface AvatarInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  loggedUser?: {
    name: string;
    avatar?: string;
  };
  optionsMenuAvatar: {
    label: string;
    onClick: () => void;
    icon: keyof typeof Icons;
  }[];
  isMobile?: boolean;
}

export const AvatarInfo: FC<AvatarInfoProps> = ({ loggedUser, children, isMobile }) => {
  const menuId = uuidv4();

  return (
    <>
      <AllieAvatar
        id={menuId}
        data-testid="user-menu"
        border="1px solid var(--allie-color-neutral-30)"
        height={isMobile ? 32 : 40}
        style={{
          cursor: 'pointer',
          borderRadius: '100%',
          border: '1px solid var(--allie-color-neutral-30)',
        }}
        src={loggedUser?.avatar}
        name={loggedUser?.name}
        color="neutral-5"
        fgColor="neutral-50"
        textSizeRatio={2.5}
      />
      <IonPopover
        trigger={menuId}
        triggerAction="click"
        showBackdrop={false}
        arrow
        side="bottom"
        alignment="end"
        className="user-avatar-popover"
        keepContentsMounted
      >
        {children}
      </IonPopover>
    </>
  );
};
